import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { UserManagement } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/users")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <UserManagement />
    </RouteGuard>
  ),
});
